import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchHeroSliders,
  fetchHeroSlidersSuccess,
  fetchHeroSlidersFailure,
} from "../slices/herosliderSlice";

// API
const fetchHeroSliderAPI = () =>
  fetch(`${process.env.REACT_APP_API_URL}/v1/sliders`).then((res) =>
    res.json(),
  );

function* handleFetchHeroSliders() {
  try {
    const response = yield call(fetchHeroSliderAPI);

    const data =
      response?.data
        ?.filter((row) => row.is_active)
        ?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) || [];

    yield put(fetchHeroSlidersSuccess(data));
  } catch (error) {
    yield put(fetchHeroSlidersFailure(error.message));
  }
}

export default function* herosliderSaga() {
  yield takeLatest(fetchHeroSliders.type, handleFetchHeroSliders);
}
